"use strict";

//	Kilopix

import * as kpc from "../../@kilopix/core.module";
import * as kpm from "../../@kilopix/methods.module";
import * as kpu from "../../@kilopix/utils.module";

//	Modules

import { AppInterface } from "../app.interface";

//	Dom selectors

const toggleButton = document.getElementById( "toggle-button" );

//	BurgerButton

export class BurgerButton {
	constructor() {
		toggleButton.addEventListener( "click" , function( e ) {
			kpm.toggleClass( document.body, "show-nav" );
			kpm.toggleClass( this, "active" );
			
			e.preventDefault();
		});

		document.addEventListener( "click" , function( e ) {
			if ( AppInterface.appMediaQuery < 48 && 
					e.clientX < (window.innerWidth - 280) &&
					kpm.hasClass(document.body, "show-nav") ) {
				kpm.trigger( toggleButton, "click" );
			}
		});
	}

	//	Resize

	resize() {
		kpm.removeClass( toggleButton, "active" );
		kpm.removeClass( document.body, "show-nav" );
	}
}